import { EVENT_STREAM_NAMES, EVENT_STREAM_CODES } from 'Store/constants/sportTypes';

export const getStreamInfoDetail = streamId => {
  return {
    other: (EVENT_STREAM_NAMES.OTHER_TV === EVENT_STREAM_CODES[streamId]),
    bilyoner: (EVENT_STREAM_NAMES.BILYONER_TV === EVENT_STREAM_CODES[streamId]),
    both: (EVENT_STREAM_NAMES.BOTH === EVENT_STREAM_CODES[streamId])
  };
};
